import { formatDate } from '@/utils'
import { billableAmount, billableHours, RATE_PER_HOUR } from '../../../billing'
import type { Project } from '../types'

function downloadCSV(csvContent: string, filename: string) {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const link = document.createElement('a')
  const url = URL.createObjectURL(blob)

  link.setAttribute('href', url)
  link.setAttribute('download', filename)
  link.style.visibility = 'hidden'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

function escapeCSV(value: string): string {
  return `"${value.replace(/"/g, '""')}"`
}

// The billing lines a partner can paste straight into an invoice: one row per case.
export function exportBillingCSV(projects: Project[]): void {
  const headers = [
    'Case',
    'Pages',
    'Billable Hours',
    'Rate ($/hr)',
    'Amount ($)',
    'Processed Date',
  ]

  const rows = projects.map((project) => [
    escapeCSV(project.name),
    project.numberOfPages.toString(),
    billableHours(project.numberOfPages).toFixed(1),
    RATE_PER_HOUR.toString(),
    billableAmount(project.numberOfPages).toFixed(2),
    escapeCSV(formatDate(project.firstProcessedAt) || ''),
  ])

  const csvContent = [
    headers.join(','),
    ...rows.map((row) => row.join(',')),
  ].join('\n')

  const date = new Date().toISOString().split('T')[0]
  downloadCSV(csvContent, `billing-lines-${date}.csv`)
}
